import React, { Component, PropTypes, Redirect } from "react";
import {
  Addtowatchlistaction,
  getGeoInfo,
  logout,
  userprofile,
} from "../../Model/Users"; //Include Home
import { Childlock } from "../Childlock/Childlock";
import { Metadata } from "../Metadata/Metadata";
import {
  Link,
  useNavigate,
  useHistory,
  browserHistory,
} from "react-router-dom";
import { toast } from "react-toastify";
import BarLoader from "react-spinners/BarLoader";
import { isMobile } from "react-device-detect";
import {
  Encrypt,
  withRouter,
  VirsionCheck,
  Faq,
  Appsflyer,
} from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";

var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      showpopup: false,
      userData: false,
      SelectedContent: false,
      showconfirm: false,
      isLive: true,
      goldenDIcon: "",
      silverDIcon: "",
      // showShimmer: true,
    };
  }

  // handleTimeout = () => {
  //   this.setState({ showShimmer: false });
  // };

  // componentDidMount() {
  //   this.timer = setTimeout(() => {
  //     this.setState({ showShimmer: false });
  //   }, 1000);
  // }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  componentDidMount() {
    //Get Virsion Check Data
    getGeoInfo().then((country) => {
      VirsionCheck().then((vcheckres) => {
        this.setState({
          isLive: JSON.parse(vcheckres.data).data.is_live_tv,
          goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
          silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
        });

        let sessiondata = {
          seesionID: localStorage.getItem("session_id"),
          userID: localStorage.getItem("userID")
        }

        userprofile(sessiondata).then((res) => {
          var userdata = JSON.parse(res.data.message);
          if (userdata.success == false) {
            this.props.navigate("/createaccount");
          } else {
            var data = {
              action: "view",
              x_country: country,
              is_child: userdata.user_data.is_child
            };
            Addtowatchlistaction(data).then((userDatares) => {
              if (userDatares.data.message == "session_expired") {
                //Redirect To login page.
                this.props.navigate("/createaccount");
              } else {
                var userDatares = JSON.parse(userDatares.data.message);
                this.setState({
                  VirsionCheckData: vcheckres,
                  VirsionCheckDataloaded: true,
                  userData: userDatares,
                });
              }
            });
          }
        });

      });
    });
  }

  showbottommodel(data) {
    this.setState({ showpopup: true, SelectedContent: data });
  }

  closeButton() {
    this.setState({ showpopup: false, SelectedContent: false });
  }

  clearall() {
    Appsflyer("Clear All Watchlist", {});

    var data = {
      clear: "1",
      action: "delete",
    };
    Addtowatchlistaction(data).then((Response) => {
      var data = {
        action: "view",
      };

      Addtowatchlistaction(data).then((userDatares) => {
        if (userDatares.data.message == "session_expired") {
          //Redirect To login page.
          this.props.navigate("/createaccount");
        } else {
          var userDatares = JSON.parse(userDatares.data.message);
          this.setState({
            userData: userDatares,
          });
        }
      });
    });
  }

  RemoveWatchlist(id) {
    //document.getElementById(id).remove();
    var data = {
      content_id: [id],
      action: "delete",
    };
    Addtowatchlistaction(data).then((Response) => {
      this.setState({ showpopup: false, SelectedContent: false });
      var data = {
        action: "view",
      };
      Addtowatchlistaction(data).then((userDatares) => {
        if (userDatares.data.message == "session_expired") {
          //Redirect To login page.
          this.props.navigate("/createaccount");
        } else {
          var userDatares = JSON.parse(userDatares.data.message);
          this.setState({
            userData: userDatares,
          });
        }
      });
    });
  }

  watchlistconfirm() {
    this.setState({
      showconfirm: true,
    });
  }

  proceed() {
    var data = {
      clear: "1",
      action: "delete",
    };
    Addtowatchlistaction(data).then((Response) => {
      var data = {
        action: "view",
      };
      Addtowatchlistaction(data).then((userDatares) => {
        if (userDatares.data.message == "session_expired") {
          this.props.navigate("/watch-list");
        } else {
          var userDatares = JSON.parse(userDatares.data.message);
          this.setState({
            userData: userDatares,
            showconfirm: false,
          });
        }
      });
    });
  }

  cancel() {
    this.setState({
      showconfirm: false,
    });
  }


  render() {
    var showmessage = false;

    if (this.state.userData.success == false) {
      showmessage = true;
    }

    if (this.state.showconfirm == true) {
      var Watchlistconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>Are you sure you want to clear your watchlist?</h6>
            </div>
            <p
              className="temp52-modal-close"
              onClick={() => {
                this.cancel();
              }}
            >
              No
            </p>
            <button
              type="submit"
              id="sendEnquiryBtn"
              className="btn-white"
              onClick={() => {
                this.proceed();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      );
    }

    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <Metadata page="HOME" />

            <div className="dD-none">
              <header>
                <div className="mainNav pmenu">
                  <Link to="/">
                    <div className="docubayBack white">Watchlist</div>
                  </Link>
                  {!showmessage ? (
                    <span className="down-clear">
                      {" "}
                      <a
                        onClick={() => this.watchlistconfirm()}
                        className="temp52-modal-toggle"
                      >
                        CLEAR ALL
                      </a>
                    </span>
                  ) : null}
                </div>
              </header>
              <main>
                {showmessage ? (
                  <section className="mb-0">
                    <div className="notification-message watchlist-message">
                      <p>
                        <span>
                          {this.state.userData.message.split(".")[0]}.
                        </span>
                        <br />
                        {this.state.userData.message.split(".")[1]}
                      </p>
                    </div>
                  </section>
                ) : (
                  <section className="mb-0">
                    <div className="temp47">
                      <div className="temp47-inn">
                        {this.state.userData.contents.map((data, index) => {
                          return (
                            <div
                              className="temp47-area watchlist"
                              id={data.ID}
                              key={data.ID}
                            >
                              {/* {this.showShimmer ? (
                                <div className="LiveLayout">
                                  <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" style={{ width: "200px" }} />
                                  <div className="LineSkeleton" >
                                    <div className="linewatchlist" />
                                    <div className="linewatchlist" />
                                    <div className="linewatchlist" />
                                  </div>
                                  <div className="lineBtn" />
                                </div>

                              ) : (
                                <>     </>)} */}
                              <div
                                className="tdot bannerpop-modal-toggle"
                                onClick={() => this.showbottommodel(data)}
                              >
                                {" "}
                                <img
                                  src={ImageData["three-dot.png"]}
                                  alt="DocuBay"
                                />{" "}
                              </div>
                              <Link to={"/" + data.slug}>
                                <div className="img-area">
                                  <img
                                    src={data.banner_image.small}
                                    alt="DocuBay"
                                  />
                                </div>
                              </Link>
                              <div className="temp47-right p-0">
                                <h6>
                                  {data.new ? (
                                    <>
                                      New
                                      <span className="dot" />
                                      &nbsp;
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  {data.premium && !data.original_tag ? (
                                    <img
                                      src={this.state.silverDIcon}
                                      alt="DocuBay"
                                      style={{
                                        width: "18px",
                                        marginRight: "3px",
                                        marginBottom: "2px",
                                      }}
                                    />
                                  ) : null}
                                  {data.original_tag && data.premium ? (
                                    <img
                                      src={this.state.goldenDIcon}
                                      alt="DocuBay"
                                      style={{
                                        width: "18px",
                                        marginRight: "3px",
                                        marginBottom: "2px",
                                      }}
                                    />
                                  ) : null}
                                  {data.release_date}
                                  {data.duration / 60 == 0 ? "" : <><span className="dot" /> {data.duration / 60} Mins</>}
                                  &nbsp;
                                  {!data.premium && !data.original_tag ? (
                                    <>
                                      Free
                                    </>
                                  ) : null}
                                  {data.video_4k ? (
                                    <span className="nBay1">4K</span>
                                  ) : data.video_hd ? (
                                    <span className="nBay1">HD</span>
                                  ) : null}
                                </h6>
                                <div className="temp47-headInn">
                                  <div className="btn-watch nBay2">
                                    {" "}
                                    {data.content_category}{" "}
                                    {data.age_restriction}{" "}
                                  </div>
                                  <div className="btn-watch">
                                    {" "}
                                    {data.genres_assign[0].name}{" "}
                                  </div>
                                  <div className="btn-watch">
                                    {" "}
                                    {data.keywords}{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </section>
                )}
              </main>
              {this.state.showpopup ? (
                <div
                  className="bannerpop"
                  id="bPop"
                  style={{ display: "flex" }}
                >
                  <div className="bannerpop-modal-body">
                    <button
                      className="bannerpop-modal-close bannerpop-modal-toggle"
                      onClick={() => {
                        this.closeButton();
                      }}
                    >
                      <img src="img/svg/promocode-close.svg" alt="DocuBay" />
                    </button>
                    <div className="bannerpop-awesome">
                      <div>
                        <h5>{this.state.SelectedContent.title}</h5>
                        <Link to={"/" + this.state.SelectedContent.slug}>
                          <h6>
                            <img src={SVGIcon["more-info.svg"]} /> More Info
                          </h6>
                        </Link>
                      </div>
                      <h6
                        onClick={() => {
                          this.RemoveWatchlist(this.state.SelectedContent.ID);
                        }}
                      >
                        <img src={SVGIcon["remove-list.svg"]} /> Remove from
                        List
                      </h6>
                    </div>
                  </div>
                </div>
              ) : null}
              <Mobilemenu active="4" isLive={this.state.isLive} />
            </div>

            {/* desktop section */}

            <div className="dD-block">
              {showmessage ? (
                <section className="mb-0">
                  <div className="watchlistNav1">
                    <Link to="/">
                      <div className="docubayBack white">
                        <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                      </div>
                    </Link>
                    <div className="temp47-title">Watchlist</div>
                  </div>
                  <div className="watchlist-message">
                    <p>
                      <span>{this.state.userData.message.split(".")[0]}.</span>
                      <br />
                      {this.state.userData.message.split(".")[1]}
                    </p>
                  </div>
                </section>
              ) : (
                <section className="mb-0">
                  <div className="temp47">
                    <div className="watchlistNav">
                      <Link to="/">
                        <div className="docubayBack white">
                          <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                        </div>
                      </Link>
                      <div className="temp47-title">Watchlist</div>
                      {!showmessage ? (
                        <span className="down-clear">
                          {" "}
                          <a
                            onClick={() => this.watchlistconfirm()}
                            className="temp52-modal-toggle"
                          >
                            CLEAR ALL
                          </a>
                        </span>
                      ) : null}
                    </div>
                    <div className="temp47-inn">
                      {this.state.userData.contents.map((data, index) => {
                        return (
                          <div
                            className="temp47-area watchlist"
                            id={data.ID}
                            key={data.ID}
                          >
                            {/* <div
                              className="tdot bannerpop-modal-toggle">
                              <img
                                onClick={() => { this.RemoveWatchlist(data.ID) }}
                                src={ImageData["Delete-Icon-1.png"]}
                                alt="DocuBay"
                              />{" "}
                            </div> */}
                            { }
                            {/* {this.showShimmer ? (
                              <div className="LiveLayout">
                                <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" />
                                <div className="LineSkeleton">
                                  <div className="linewatchlist" />
                                  <div className="linewatchlist" />
                                  <div className="linewatchlist" />
                                  <div className="linewatchlist" />
                                </div>
                                <div className="lineBtn" />
                              </div>

                            ) : (
                              <>
                              </>)} */}
                            <Link to={"/" + data.slug}>
                              <div className="temp47area-main">
                                <div className="img-area">
                                  <img
                                    src={data.banner_image.small}
                                    alt="DocuBay"
                                  />
                                </div>
                                {/* <div className="temp47-play">
                                  <img src={SVGIcon["play.svg"]} className="btn1" />
                                </div> */}
                              </div>
                            </Link>
                            <div className="temp47-right p-0">
                              <h6>
                                {data.new ? (
                                  <>
                                    New
                                    <span className="dot" />
                                    &nbsp;
                                  </>
                                ) : (
                                  ""
                                )}
                                {data.premium && !data.original_tag ? (
                                  <img
                                    src={this.state.silverDIcon}
                                    alt="DocuBay"
                                    style={{
                                      width: "20px",
                                      marginRight: "3px",
                                      marginBottom: "2px",
                                    }}
                                  />
                                ) : null}
                                {data.original_tag && data.premium ? (
                                  <img
                                    src={this.state.goldenDIcon}
                                    alt="DocuBay"
                                    style={{
                                      width: "20px",
                                      marginRight: "3px",
                                      marginBottom: "2px",
                                    }}
                                  />
                                ) : null}
                                {data.release_date}
                                {data.duration / 60 == 0 ? "" : <><span className="dot" /> {data.duration / 60} Mins</>}
                                &nbsp;
                                {!data.premium && !data.original_tag ? (
                                  <>
                                    Free
                                  </>
                                ) : null}
                                {data.video_4k ? (
                                  <span className="nBay1">4K</span>
                                ) : data.video_hd ? (
                                  <span className="nBay1">HD</span>
                                ) : null}
                              </h6>
                              <div className="temp47-headInn">
                                <div className="btn-watch nBay2">
                                  {" "}
                                  {data.content_category} {data.age_restriction}{" "}
                                </div>
                                <div className="btn-watch">
                                  {" "}
                                  {data.genres_assign[0].name}{" "}
                                </div>
                                <div className="btn-watch">
                                  {" "}
                                  {data.keywords}{" "}
                                </div>
                              </div>
                              <div className="temp47-headInn1">
                                <Link to={"/" + data.slug}>
                                  <h6>
                                    <img
                                      src={SVGIcon["More-Info-Icon-01.svg"]}
                                    />{" "}
                                    More Info
                                  </h6>
                                </Link>
                                <h6
                                  onClick={() => {
                                    this.RemoveWatchlist(data.ID);
                                  }}
                                  className="removelist"
                                >
                                  <img src={ImageData["Delete-Icon-1.png"]} />
                                  Remove from list
                                </h6>
                              </div>
                            </div>

                          </div>
                        );
                      })}
                    </div>
                  </div>
                </section>
              )}
              {this.state.showpopup ? (
                <div
                  className="bannerpop"
                  id="bPop"
                  style={{ display: "flex" }}
                >
                  <div className="bannerpop-modal-body">
                    <button
                      className="bannerpop-modal-close bannerpop-modal-toggle"
                      onClick={() => {
                        this.closeButton();
                      }}
                    >
                      <img src="img/svg/promocode-close.svg" alt="Docubay" />
                    </button>
                    <div className="bannerpop-awesome">
                      <h5>{this.state.SelectedContent.title}</h5>
                      <Link to={"/" + this.state.SelectedContent.slug}>
                        <h6>
                          <img src={SVGIcon["more-info.svg"]} /> More Info
                        </h6>
                      </Link>
                      <h6
                        onClick={() => {
                          this.RemoveWatchlist(this.state.SelectedContent.ID);
                        }}
                      >
                        <img src={SVGIcon["remove-list.svg"]} /> Remove from
                        List
                      </h6>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {Watchlistconfirm}
            {this.state.userData != false ? (
              <Childlock data={this.state.userData} />
            ) : null}
            {/* <Mobilemenu active="4" /> */}
            {!isMobile ? null : (
              <Mobilemenu active="4" isLive={this.state.isLive} />
            )}
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Signup);
